<div class="d-flex w-100 flex-column min-vh-100">

  <app-header class="w-100" [loggedInUsername]="loggedInUsername$ | async" [layoutDispositivoXs]="layoutDispositivoXs"></app-header>
  <div class="card flex justify-content-center" style="margin-bottom: 5px; margin-top: 5px;">
    <p-breadcrumb class="max-w-full"  
        (onItemClick)="onBreadcrumbClick($event)" 
        [model]="breadcrumbItems" [home]="{label: 'Portal do Contribuinte'}">
        <ng-template #separator> / </ng-template>
    </p-breadcrumb>

  </div>
  <div class="d-flex main-content-div p-3 flex-grow-1">
    <ng-template [ngIf]="authService.isLoggedIn()">
      <div class="content-border-no-left">
        <app-menu></app-menu>
      </div>
    </ng-template>
    <div class="content-border-no-right w-100  position-relative">
      <router-outlet [layoutDispositivoXs]="layoutDispositivoXs"></router-outlet>
    </div>
  </div>
  <sfz-footer
    hideLogo="true"
    iconsTitle="Superintendência de Tecnologia da Informação - SUTI - Versão: {{ version }}"
    center = true >
  </sfz-footer>
  
</div>
